module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-009"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIII",
      "title": "XIII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('b', [_vm._v("ABBREVIATIONS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("ACCS")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Ancient Christian Commentary on Scripture. 29 vols. Edited by Thomas C. Oden. Downers Grove, IL: InterVarsity Press, 1998–2009.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("CRR")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Classics of the Radical Reformation. 12 vols. Waterloo, ON, and Scottdale, PA: Herald Press, 1973–2010.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("CWE")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Collected Works of Erasmus")]), _vm._v(". 86 vols. planned. Toronto: University of Toronto Press, 1969–.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LCC")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Library of Christian Classics. 26 vols. Edited by John Baillie et al. Philadelphia: Westminster Press, 1953–1966.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LCL")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Loeb Classical Library")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LW")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Luther’s Works ")]), _vm._v("["), _c('i', [_vm._v("American Edition")]), _vm._v("]. 82 vols. planned. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986, 2009–.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("PE")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Works of Martin Luther: With Introduction and Notes [= “Philadelphia Edition”]. Philadelphia: Muhlenberg, 1915–1943.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("RCS")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Reformation Commentary on Scripture. 28 vols. projected. Edited by Timothy George and Scott M. Manetsch. Downers Grove, IL: IVP Academic, 2011–.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("SMRT")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Studies in Medieval and Reformation Traditions")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WA")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke: Kritische Gesamtausgabe: [Schriften]")]), _vm._v(". 73 vols. Weimar: Hermann Böhlaus Nachfolger, 1883–2009. Digital copy online at archive.org.")])])])])])])]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIV",
      "title": "XIV"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 72
// module chunks = 0